import React, { useState } from "react";
import { Table } from "antd";

import ProcedureDropdown from "./ProcedureDropdown";

// This table is not for procedures
export default function InsurancePatientProceduresTable({
  insurances,
  allProcedures,
  currentPatientID,
  approvedPatients,
  disabledByApproved,
  approvedProcedures,
  setMarkedProcedures,
  setApprovedProcedures,
  isSettingProcedureCode,
  setIsSettingProcedureCode,
  setEmptyProcedureDropdown,
  predeterminationOrPostPayment,
}) {
  const [procedureName, setProcedureName] = useState(undefined);

  // Predetermination Columns: Procedures, Tooth/Quad, Estimated Cost, Insurance Estiamte, Discount, Patient Responsibility
  // Post Payment Columns: Extracted Procedures, Related Procedure, Tooth/Quad, Estimated Cost, Eligible Amount, Paid Amount, Claim Date
  const proceduresColumns = [
    {
      title: `${predeterminationOrPostPayment === "post-paymment" ? "Extracted" : ""} Procedures`,
      key: "tem_procedure",
      render: (code, record) => {
        const { temp_procedure_code, temp_procedure_des, procedure_code } = record;
        return temp_procedure_code ? `${temp_procedure_code} ${temp_procedure_des ? `- ${temp_procedure_des}` : ""}` : procedure_code;
      },
    },
    {
      title: "Related Procedure",
      dataIndex: "procedure_code",
      width: 260,
      key: "procedure_code",
      hidden: predeterminationOrPostPayment === "predetermination",
      render: (_, record) => (
        <ProcedureDropdown
          insurances={insurances}
          currentProcedure={record}
          procedureName={procedureName}
          allProcedures={allProcedures}
          approvedPatients={approvedPatients}
          currentPatientID={currentPatientID}
          setProcedureName={setProcedureName}
          numberOfInsurances={insurances.length}
          disabledByApproved={disabledByApproved}
          approvedProcedures={approvedProcedures}
          setApprovedProcedures={setApprovedProcedures}
          isSettingProcedureCode={isSettingProcedureCode}
          setIsSettingProcedureCode={setIsSettingProcedureCode}
          setEmptyProcedureDropdown={setEmptyProcedureDropdown}
        />
      ),
    },
    {
      title: "Tooth/Quad",
      dataIndex: "tooth",
      key: "tooth",
      render: (tooth) => tooth || "-",
    },
    {
      title: "Estimated Cost",
      dataIndex: "estimated_cost",
      key: "estimated_cost",
      render: (estimate) => (estimate ? `$${parseFloat(estimate).toFixed(2)}` : "-"),
    },
    {
      title: "Insurance Estimate",
      dataIndex: "insurance_estimate",
      key: "insurance_estimate",
      hidden: predeterminationOrPostPayment === "post-payment",
      render: (amount) => (amount ? `$${parseFloat(amount).toFixed(2)}` : "-"),
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      hidden: predeterminationOrPostPayment === "post-payment",
      render: (amount) => (amount ? `$${parseFloat(amount).toFixed(2)}` : "-"),
    },
    {
      title: "Patient Responsibility",
      dataIndex: "patient_responsibility",
      key: "patient_responsibility",
      hidden: predeterminationOrPostPayment === "post-payment",
      render: (amount) => (amount ? `$${parseFloat(amount).toFixed(2)}` : "-"),
    },
    {
      title: "Paid Amount",
      dataIndex: "paid_amount",
      key: "paid_amount",
      hidden: predeterminationOrPostPayment === "predetermination",
      render: (amount) => (amount ? `$${parseFloat(amount).toFixed(2)}` : "-"),
    },
    {
      title: "Claim Date",
      dataIndex: "claim_date",
      key: "claim_date",
      hidden: predeterminationOrPostPayment === "predetermination",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "-"),
    },
  ];

  return (
    <Table
      dataSource={insurances}
      columns={proceduresColumns}
      rowKey="id"
      pagination={false}
      scroll={{ x: 1300 }}
      rowSelection={
        predeterminationOrPostPayment === "predetermination"
          ? {
              type: "checkbox",
              onChange: (newSelectedPatients) => {
                setMarkedProcedures(newSelectedPatients);
              },
            }
          : null
      }
    />
  );
}
